/**
 * The checkout step bar.
 *
 * Markup contract:
 *   <div class="checkout_steps" x-data="checkoutSteps({ canonicalUrl: '…' })">
 *     … <a href="…" @click.prevent="submitStep('payment')">
 *
 * A step that lies ahead is only reachable by sending the current step, so the
 * link sends its form instead of following its href; the href stays the address
 * the step would have. The canonical url replaces the address a POST left behind.
 */
document.addEventListener('alpine:init', () => {
    Alpine.data('checkoutSteps', ({ canonicalUrl = '' } = {}) => ({
        init() {
            if (canonicalUrl) {
                history.replaceState(null, document.title, canonicalUrl);
            }
        },

        submitStep(formId) {
            document.getElementById(formId).requestSubmit();
        },
    }));
});
